<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <div class="footer-content">
        <!-- Colonna 1: Informazioni Azienda -->
        <FooterColumn title="ISIGest S.r.l.">
          <FooterText>
            Sede legale:<br>
            Napoli (NA)<br>
            Centro Direzionale Napoli<br>
            Isola G1 Scala C Interno 94
          </FooterText>
        </FooterColumn>

        <!-- Colonna 2: Contatti -->
        <FooterColumn title="Contatti">
          <FooterLinksList>
            <FooterLink
              href="mailto:info@appscontrini.it"
              icon="fas fa-envelope"
            >
              info@appscontrini.it
            </FooterLink>
            <FooterLink
              href="mailto:info@isigest.net"
              icon="fas fa-envelope"
            >
              info@isigest.net
            </FooterLink>
            <FooterLink
              href="tel:+390828725141"
              icon="fas fa-phone"
            >
              +39 0828 725141
            </FooterLink>
            <FooterLink
              href="https://www.isigest.net"
              icon="fas fa-globe"
              target="_blank"
              rel="noopener"
            >
              www.isigest.net
            </FooterLink>
          </FooterLinksList>
        </FooterColumn>

        <!-- Colonna 3: Link Utili -->
        <FooterColumn title="Link Utili">
          <FooterLinksList>
            <FooterLink
              to="/"
              icon="fas fa-home"
            >
              Home
            </FooterLink>
            <FooterLink
              to="/contattaci"
              icon="fas fa-envelope-open-text"
            >
              Contattaci
            </FooterLink>
            <FooterLink
              to="/privacy"
              icon="fas fa-shield-alt"
            >
              Privacy Policy
            </FooterLink>
            <FooterLink
              to="/cancellazione-dati"
              icon="fas fa-user-slash"
            >
              Cancellazione Dati
            </FooterLink>
            <FooterLink
              href="https://www.lotteriadegliscontrini.gov.it"
              icon="fas fa-external-link-alt"
              target="_blank"
              rel="noopener"
            >
              Sito Ufficiale Lotteria
            </FooterLink>
          </FooterLinksList>
        </FooterColumn>

        <!-- Colonna 4: App Info -->
        <FooterColumn title="App degli Scontrini">
          <FooterText>
            Partecipa alla Lotteria degli Scontrini in modo semplice e veloce.
          </FooterText>
          <FooterBadgesList>
            <FooterBadge
              icon="fab fa-apple"
              @click="scrollToDownload"
            >
              App Store
            </FooterBadge>
            <FooterBadge
              icon="fab fa-google-play"
              @click="scrollToDownload"
            >
              Google Play
            </FooterBadge>
          </FooterBadgesList>
        </FooterColumn>
      </div>

      <!-- Footer Bottom -->
      <FooterBottom />
    </div>
  </footer>
</template>

<script>
import FooterColumn from './footer/FooterColumn.vue'
import FooterText from './footer/FooterText.vue'
import FooterLinksList from './footer/FooterLinksList.vue'
import FooterLink from './footer/FooterLink.vue'
import FooterBadgesList from './footer/FooterBadgesList.vue'
import FooterBadge from './footer/FooterBadge.vue'
import FooterBottom from './footer/FooterBottom.vue'

export default {
  name: 'Footer',
  components: {
    FooterColumn,
    FooterText,
    FooterLinksList,
    FooterLink,
    FooterBadgesList,
    FooterBadge,
    FooterBottom
  },
  methods: {
    scrollToDownload() {
      if (this.$route.path === '/') {
        const element = document.querySelector('#download')
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      } else {
        this.$router.push({ path: '/', hash: '#download' }).then(() => {
          setTimeout(() => {
            const element = document.querySelector('#download')
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' })
            }
          }, 100)
        })
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  color: #ffffff;
  padding: 4rem 0 1.5rem;
  margin-top: 4rem;
  overflow: hidden;
  width: 100%;
}

.footer-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  width: 100%;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.03) 0%, transparent 50%);
  pointer-events: none;
}

.footer::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 100%
  );
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2.5rem;
  margin-bottom: 2.5rem;
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.8s ease-out;
}

/* Desktop: forza 4 colonne su una riga con gap ottimizzato */
@media (min-width: 1200px) {
  .footer-wrapper {
    padding: 0 3rem;
  }
  
  .footer-content {
    grid-template-columns: repeat(4, 1fr);
    gap: 3rem;
  }
}

/* Desktop grande: sfrutta ancora più spazio */
@media (min-width: 1400px) {
  .footer-wrapper {
    padding: 0 4rem;
  }
  
  .footer-content {
    gap: 4rem;
  }
}

/* Tablet: 2 colonne */
@media (min-width: 769px) and (max-width: 1199px) {
  .footer-wrapper {
    padding: 0 2.5rem;
  }
  
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer {
    padding: 2rem 0 1rem;
  }

  .footer-wrapper {
    padding: 0 1.5rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 576px) {
  .footer {
    padding: 1.5rem 0 1rem;
  }

  .footer-wrapper {
    padding: 0 1rem;
  }

  .footer-content {
    gap: 1.5rem;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

